import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BaseWidgetTypeConfigComponent } from '@clean-code/shared/dashboard/widget/api-widget';
import { PatchFormGroupValuesDirective } from '@clean-code/shared/directives/ui-form';
import { TranslocoModule } from '@jsverse/transloco';
import { NgSelectModule } from '@ng-select/ng-select';
import { map } from 'rxjs/operators';
import type { MarketCustomerAnalysisWidgetLayout } from '../market-customer-analysis-widget.models';
import { MarketCustomerAnalysisWidgetTypeConfig } from '../market-customer-analysis-widget.models';
import { MarketCustomerAnalysisWidgetService } from '../services/market-customer-analysis-widget.service';
import { WidgetCompany } from '../widget-company';
@Component({
  selector: 'dashboard-market-customer-analysis-widget-config',
  templateUrl: './market-customer-analysis-widget-config.component.html',
  styleUrls: ['./market-customer-analysis-widget-config.component.css'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslocoModule,
    PatchFormGroupValuesDirective,
  ],
})
export class MarketCustomerAnalysisWidgetConfigComponent extends BaseWidgetTypeConfigComponent<MarketCustomerAnalysisWidgetTypeConfig> {
  override form = new UntypedFormGroup({
    companyId: new UntypedFormControl('', Validators.required),
    layout: new UntypedFormControl('auto', Validators.required),
  });

  private companyService = inject(MarketCustomerAnalysisWidgetService);
  public companies$ = this.companyService
    .getAllCompanies$()
    .pipe(map((data: WidgetCompany[]) => data.filter((x) => !x.disabled)));

  public readonly layoutOptions: MarketCustomerAnalysisWidgetLayout[] = [
    'auto',
    'vertical',
    'horizontal',
  ];

  public getLayoutLabelKey(layout: MarketCustomerAnalysisWidgetLayout): string {
    switch (layout) {
      case 'auto':
        return 'widgetType-MarketCustomerAnalysis.layoutOptions.AUTO';
      case 'vertical':
        return 'widgetType-MarketCustomerAnalysis.layoutOptions.VERTICAL';
      case 'horizontal':
        return 'widgetType-MarketCustomerAnalysis.layoutOptions.HORIZONTAL';
    }
  }

  public close(): void {
    //TODO: dashboard state
    // this.callback.next();
  }
}
